import { render, staticRenderFns } from "./AppOffersView.vue?vue&type=template&id=48fbaa76&scoped=true&"
import script from "./AppOffersView.vue?vue&type=script&lang=js&"
export * from "./AppOffersView.vue?vue&type=script&lang=js&"
import style0 from "./AppOffersView.vue?vue&type=style&index=0&id=48fbaa76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbaa76",
  null
  
)

export default component.exports